import {AppController} from "@ok/web/modules/block/AppController";
import {RbAdBannerFullScreenStore} from "./RbAdBannerFullScreenStore";

export class RbAdBannerFullScreenController extends AppController<RbAdBannerFullScreenStore> {
}
